<template>
    <div>
        <div class="d-flex justify-center">
            <p style="font-weight: bolder">Création de compte entreprise</p>
        </div>
        <v-row>
            <v-col class="d-flex align-center justify-start">
                <v-btn-back v-if="isUserStep && !ended" @click="getBack()" class="ml-8">
                </v-btn-back>
            </v-col>
            <v-col class="d-flex align-center justify-center">
                <v-progress-linear
                    v-if="step_ != 5"
                    color="primary"
                    height="20"
                    rounded
                    :model-value="(step_ / 4) * 100"
                >
                    <template v-slot:default="{ value }">
                        <strong style="color: white">{{ step_ + 1 }} / 5</strong>
                    </template>
                </v-progress-linear>
            </v-col>
            <v-col class="d-flex align-center justify-end"
                ><v-btn
                    class="button mr-8"
                    rounded
                    elevation="0"
                    @click="validNextStep()"
                    :loading="loading"
                    size="small"
                    location="end"
                    >{{ actionButtonWording }}</v-btn
                ></v-col
            >
        </v-row>
    </div>
</template>

<script lang="ts">
import { Register_Step } from "@/types/registerServices.types";
import { Offer_type } from "@/types/offer.types";
import { Component, Vue, toNative, Model, Prop, Emit } from "vue-facing-decorator";

@Component
export class RegisterButton extends Vue {
    @Model({ default: 0, name: "step" }) step_: number;
    @Prop({ default: Offer_type.ACCOUNTING_BASIC }) offer: Offer_type;
    @Prop({ default: false }) loading: boolean;
    @Prop({ default: false }) ended: boolean;

    @Emit
    validNextStep() {
        return "";
    }

    getBack() {
        switch (this.step_) {
            case Register_Step.USER_STEP:
                break;
            case Register_Step.COMPANY_STEP:
                this.step_ = Register_Step.USER_STEP;
                break;
            case Register_Step.ACCOUNTING_STEP:
                this.step_ = Register_Step.OFFER_STEP;
                break;
            case Register_Step.OFFER_STEP:
                this.step_ = Register_Step.COMPANY_STEP;
                break;
            case Register_Step.DECLARATION_STEP:
                this.step_ = Register_Step.RESUME_STEP;
                break;
            case Register_Step.RESUME_STEP:
                this.step_ = Register_Step.ACCOUNTING_STEP;
                break;
            case Register_Step.END_STEP:
                this.step_ = Register_Step.RESUME_STEP;
        }
    }

    get actionButtonWording() {
        switch (this.step_) {
            case Register_Step.USER_STEP:
            case Register_Step.COMPANY_STEP:
            case Register_Step.ACCOUNTING_STEP:
            case Register_Step.OFFER_STEP:
            case Register_Step.DECLARATION_STEP:
                return "Suivant";
            case Register_Step.RESUME_STEP:
                return "Créer mon compte";
            case Register_Step.END_STEP:
                return "Revenir à l'écran de connexion";
        }
    }

    get isUserStep() {
        if (this.step_ == Register_Step.USER_STEP) {
            return false;
        }
        return true;
    }
}

export default toNative(RegisterButton);
</script>

<style>
.card {
    background-color: white;
    border-radius: 20px;
}

.button {
    font-size: xx-small !important;
}
</style>
